import type { SituatieServiciiUEData } from "@/types/entity";

const MSG_SELECT = "Selectează o opțiune";
const MSG_STATE_UE =
  "Adaugă cel puțin un stat membru UE în care furnizezi servicii";
const MSG_ADRESE_UE = "Adaugă cel puțin o adresă din statele membre UE";

export function validateSituatieServiciiUE(
  data: SituatieServiciiUEData | null | undefined
): Record<string, string> {
  const errors: Record<string, string> = {};

  if (data?.furnizeaza_servicii_romania == null) {
    errors["situatie_servicii_ue.furnizeaza_servicii_romania"] = MSG_SELECT;
  }
  if (data?.furnizeaza_servicii_ue == null) {
    errors["situatie_servicii_ue.furnizeaza_servicii_ue"] = MSG_SELECT;
  }

  if (data?.furnizeaza_servicii_ue === true) {
    const states = (data.state_membre_ue ?? "").trim();
    const hasValidState = states !== "";
    if (!hasValidState) {
      errors["situatie_servicii_ue.state_membre_ue"] = MSG_STATE_UE;
    }
    const addresses = (data.adrese_ue ?? "").trim();
    if (addresses === "") {
      errors["situatie_servicii_ue.adrese_ue"] = MSG_ADRESE_UE;
    }
  }

  return errors;
}
